import {Avatar, Dropdown, Flex, MenuProps, Typography} from "antd";
import React from "react";
import {UserOutlined} from "@ant-design/icons";
import {AuthService} from "../../../services/AuthService";
import {useNavigate} from "react-router-dom";
import {Paths} from "../../../models/Paths";
import {SwitchUserModal} from "../../../components/Common/SwitchUserModal/SwitchUserModal";
import {useModal} from "../../../utils/modals";
import {ChangePasswordModal} from "../../../components/Login/ChangePasswordModal";

export interface UserMenuProps {
    image?: any;
    username: string | undefined;
    lastname?: string | undefined;
    reloadOperator: ()=>void;
}

export enum UserMenuRoutes{
    LogoutButton='logoutButton',
    ChangePassword='changePassword',
    SwitchOperator='switchOperator',
    LoadOperators='loadOperators',
    LoadLoggedEvents='loadLoggedEvents',
    ManageInsuranceProviders='manageInsuranceProviders',
    ManageContracts='manageContracts',
    Procedures='procedures'
}

export function UserMenu(props: UserMenuProps) {
    const {Text} = Typography;
    const navigate = useNavigate();
    const {
        isOpen: isSwitchOperatorOpen,
        open: openSwitchOperatorModal,
        close: closeSwitchOperatorModal
    } = useModal();

    const {
        isOpen: isChangePasswordOpen,
        open: openChangePasswordModal,
        close: closeChangePasswordModal
    } = useModal();

    const doLogout = () => {
        AuthService.logout()
            .then(() => {
                navigate(Paths.LOGIN)
            });
    }

    function goOperatorsPage() {
        navigate(Paths.OPERATORS);
    }
    function goLoggedEventsPage() {
        navigate(Paths.LOGGED_EVENTS);
    }
    function goInsuranceProviderManagementPage() {
        navigate(Paths.INSURANCE_PROVIDERS);
    }
    function goContractManagementPage() {
        navigate(Paths.CONTRACTS);
    }
    function goProceduresPage() {
        navigate(Paths.PROCEDURES);
    }

    const handleClick: MenuProps['onClick'] = (e) => {
        if (e.key === UserMenuRoutes.LogoutButton) {
            doLogout();
        }
        if (e.key === UserMenuRoutes.ChangePassword) {
            openChangePasswordModal();
        }
        if (AuthService.isAdmin() && e.key === UserMenuRoutes.LoadOperators) {
            goOperatorsPage()
        }
        if (AuthService.isAdmin() && e.key === UserMenuRoutes.LoadLoggedEvents) {
            goLoggedEventsPage()
        }
        if (AuthService.isAdmin() && e.key === UserMenuRoutes.ManageInsuranceProviders) {
            goInsuranceProviderManagementPage()
        }
        if (AuthService.isAdmin() && e.key === UserMenuRoutes.ManageContracts) {
            goContractManagementPage()
        }
        if (AuthService.isAdmin() && e.key === UserMenuRoutes.Procedures) {
            goProceduresPage()
        }
        if (e.key === 'switchOperator') {
            openSwitchOperatorModal();
        }
    }

    function authMenu() {
        let dropdownItems = [
            {
                label: 'Cambia Operatore',
                key: UserMenuRoutes.SwitchOperator
            },
            {
                label: 'Cambia Password',
                key: UserMenuRoutes.ChangePassword
            }
        ];
        if (AuthService.isAdmin()) {
            dropdownItems = [...dropdownItems,
                {
                    label: 'Carica Operatori',
                    key: UserMenuRoutes.LoadOperators
                }, {
                    label: 'Carica Eventi Registrati',
                    key: UserMenuRoutes.LoadLoggedEvents
                }, {
                    label: 'Gestione Assicurazioni',
                    key: UserMenuRoutes.ManageInsuranceProviders
                }, {
                    label: 'Gestione Contratti',
                    key: UserMenuRoutes.ManageContracts
                }, {
                    label: 'Gestione Procedure',
                    key: UserMenuRoutes.Procedures
                }
            ]
        }

        dropdownItems.push({
            label: 'Logout',
            key: UserMenuRoutes.LogoutButton
        })

        return dropdownItems;
    }

    function onOk(){
        closeSwitchOperatorModal();
        props.reloadOperator()
    }

    return (
        <div className={"user-menu"}>
            <Flex align={"center"}>
                <Flex vertical style={{marginRight: '10px'}}>
                    <Text>{props.username}</Text>
                    <Text>{props.lastname}</Text>
                </Flex>
                <Dropdown menu={{ items: authMenu(), onClick: handleClick }} trigger={['click']}>
                    <a onClick={(e) => e.preventDefault()}>
                        <Avatar size="large" icon={<UserOutlined/>}/>
                    </a>
                </Dropdown>
                { isSwitchOperatorOpen && <SwitchUserModal isOpen={isSwitchOperatorOpen} onOk={onOk} onCancel={closeSwitchOperatorModal}></SwitchUserModal> }
                { isChangePasswordOpen && <ChangePasswordModal isOpen={isChangePasswordOpen} onOk={closeChangePasswordModal} onCancel={closeChangePasswordModal}></ChangePasswordModal> }
            </Flex>
        </div>
    );
}
